import { useMemo } from 'react';

import { useMy } from '@/hooks/useMy';
import { RiskSeverity } from '@/types';

export interface RiskCountsResult {
  [RiskSeverity.Critical]: number;
  [RiskSeverity.High]: number;
  [RiskSeverity.Medium]: number;
  [RiskSeverity.Low]: number;
  [RiskSeverity.Info]: number;
  total: number;
}

export function useCustomerRiskCounts() {
  const query = useMy(
    {
      resource: 'statistic',
      query: 'my#status:O#now',
      desc: true,
      allTenants: true,
    },
    {
      doNotImpersonate: true, // Customer management should always run as the actual user
    }
  );

  const dataMap = useMemo(
    () =>
      new Map(
        query.data?.map(item => [
          `${item.username}#${item.value}`,
          item?.data?.count || 0,
        ]) || []
      ),
    [query.data]
  );

  return {
    ...query,
    dataMap,
  };
}
